import { useLayoutEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const STRIP =
  '© 2026 SAN JUAN · PRIVACY · TERMS · COOKIE POLICY · PUERTO RICO · MMXXVI · ';

export default function Footer() {
  const rootRef = useRef<HTMLElement>(null);

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (prefersReduced) {
        gsap.set('.site-footer__inner', { scale: 1, opacity: 1 });
        return;
      }

      gsap.fromTo(
        '.site-footer__inner',
        { scale: 0.9, opacity: 0.5 },
        {
          scale: 1,
          opacity: 1,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: rootRef.current,
            start: 'top 90%',
            end: 'top 30%',
            scrub: true,
          },
        }
      );
    }, rootRef);
    return () => ctx.revert();
  }, []);

  return (
    <footer ref={rootRef} className="site-footer" id="reserve">
      <div className="site-footer__inner">
        <h2 className="site-footer__title">
          Begin Your Journey<span className="site-footer__dot">.</span>
        </h2>
        <a href="#reserve" className="site-footer__cta tlink" data-cursor="expand">
          Reserve your stay →
        </a>
      </div>
      <div className="site-footer__strip" aria-hidden="true">
        <div className="site-footer__marquee">
          <span>{STRIP.repeat(4)}</span>
          <span>{STRIP.repeat(4)}</span>
        </div>
      </div>
    </footer>
  );
}